import RelationSummary from './relation-summary';
export default RelationSummary;
